import { useCallback, useEffect, useRef } from "react";

export const usePolling = () => {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startPolling = useCallback((asyncCall: () => void, delay: number) => {
    intervalRef.current = setInterval(asyncCall, delay);
  }, []);

  const stopPolling = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  useEffect(() => {
    return () => stopPolling();
  }, []);

  return { startPolling, stopPolling };
};
